module.exports = __webpack_public_path__ + "img/2.1ddb5517.png";